import { render, staticRenderFns } from "./permission-admin.vue?vue&type=template&id=020f1ae7&scoped=true"
import script from "./permission-admin.vue?vue&type=script&lang=ts"
export * from "./permission-admin.vue?vue&type=script&lang=ts"
import style0 from "./permission-admin.vue?vue&type=style&index=0&id=020f1ae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f1ae7",
  null
  
)

export default component.exports